import {
  reactive,
  toRefs,
  onMounted,
  onUnmounted,
} from '@vue/composition-api'
import { getIsBarcode } from '../helpers'

const useBarcodeScanner = (options = {}) => {
  const { delay = 100, ignoreEnter = false } = options
  const state = reactive({
    barcode: '',
    history: [],
  })
  const event = reactive({
    barcode: '',
    isRunning: false,
  })

  onMounted(() => {
    window.addEventListener('keypress', onKeypress)
  })

  onUnmounted(() => {
    window.removeEventListener('keypress', onKeypress)
  })

  const setBarcode = (barcode) => {
    state.barcode = barcode
  }

  const clearHistory = () => {
    state.history = []
  }

  const onKeypress = (e) => {
    const isAccept = /^[A-z0-9]{1}$/.test(e.key)
    const isEnter = e.key === 'Enter'
    if (isAccept) {
      event.barcode += e.key
    } else if (isEnter && ignoreEnter) {
      return e.preventDefault()
    }

    if (!event.isRunning) {
      event.isRunning = true

      setTimeout(() => {
        const isBarcode = getIsBarcode(event.barcode)
        if (isBarcode) {
          // dispatch event
          const detail = { code: event.barcode }
          const customEvent = new CustomEvent('barcode', { detail })
          window.dispatchEvent(customEvent)

          // set state
          state.barcode = event.barcode
          state.history.push(event.barcode)
          event.barcode = ''
          event.isRunning = false
        } else {
          event.barcode = ''
          event.isRunning = false
        }
      }, delay)
    }
  }

  return {
    ...toRefs(state),
    setBarcode,
    clearHistory,
  }
}

export default useBarcodeScanner



// WEBPACK FOOTER //
// ./src/use/barcodeScanner.js